module.exports = __webpack_public_path__ + "media/newstyle/images/lp-banner-a-mobile-269335d486e28af8882b88b089117368.png";